module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('h3', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.labelTitle[_vm.actualLanguage]))]), _vm._v(" "), (_vm.displayTab) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-tabs-alt nav-justified",
    attrs: {
      "data-toggle": "tabs"
    }
  }, [_c('li', {
    class: {
      'active': _vm.tabMenuSelector[0] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleTabMenuSelector(0)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" " + _vm._s(_vm.tabLabelMainService[_vm.actualLanguage]))])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.tabMenuSelector[1] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleTabMenuSelector(1)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-building"
  }), _vm._v(" " + _vm._s(_vm.tabLabelUnits[_vm.actualLanguage]))])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.tabMenuSelector[2] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleTabMenuSelector(2)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" " + _vm._s(_vm.tabLabelOccupants[_vm.actualLanguage]))])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.tabMenuSelector[3] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleTabMenuSelector(3)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-gear"
  }), _vm._v(" " + _vm._s(_vm.tabLabelComplement[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "block-content tab-content"
  }, [_c('div', {
    class: {
      'tab-pane': true, 'active': _vm.tabMenuSelector[0] == true
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.mainServiceListIsLoading) ? _c('spinner') : _c('div', _vm._l((_vm.MainServiceList), function(mainService, index) {
    return _c('div', [_c('div', {
      staticClass: "row"
    }, [_c('main-service-display', {
      attrs: {
        "mainService": mainService
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12"
    }, [_c('button', {
      staticClass: "btn btn-xs align-right",
      attrs: {
        "type": "button",
        "name": "buttonAddPlanItem"
      },
      on: {
        "click": function($event) {
          return _vm.deleteMainService(index)
        }
      }
    }, [(_vm.serviceIsDeleting) ? _c('spinner', {
      attrs: {
        "size": "small"
      }
    }) : _c('span', [_c('i', {
      staticClass: "fa fa-trash-o fa-1x push-5-r "
    }), _vm._v(_vm._s(_vm.labelButtonDeleteService[_vm.actualLanguage]))])], 1)])], 1)])
  }), 0), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "btn  btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.addMainService
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonAddMainService[_vm.actualLanguage]))])])], 1)]), _vm._v(" "), _c('div', {
    class: {
      'tab-pane': true, 'active': _vm.tabMenuSelector[1] == true
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.unitListIsLoading) ? _c('spinner') : _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('unit-display-stats', {
    attrs: {
      "unitList": _vm.UnitList
    }
  })], 1), _vm._v(" "), _vm._l((_vm.UnitList), function(unit, index) {
    return _c('div', [_c('div', {
      staticClass: "row"
    }, [_c('unit-display', {
      attrs: {
        "unit": unit
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12"
    }, [_c('button', {
      staticClass: "btn btn-xs align-right",
      attrs: {
        "type": "button",
        "name": "buttonAddPlanItem"
      },
      on: {
        "click": function($event) {
          return _vm.deleteUnit(index)
        }
      }
    }, [(_vm.unitIsDeleting) ? _c('spinner', {
      attrs: {
        "size": "small"
      }
    }) : _c('span', [_c('i', {
      staticClass: "fa fa-trash-o fa-1x push-5-r "
    }), _vm._v(_vm._s(_vm.labelButtonDeleteService[_vm.actualLanguage]))])], 1)])], 1)])
  })], 2), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "btn  btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.addUnit
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonAddUnit[_vm.actualLanguage]))])])], 1)]), _vm._v(" "), _c('div', {
    class: {
      'tab-pane': true, 'active': _vm.tabMenuSelector[2] == true
    }
  }, [(_vm.occupantListIsLoading) ? _c('spinner') : _c('div', _vm._l((_vm.occupantsList), function(occupant, index) {
    return _c('div', [_c('div', {
      staticClass: "row"
    }, [_c('occupant-display', {
      attrs: {
        "occupant": occupant
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12"
    }, [_c('button', {
      staticClass: "btn btn-xs align-right",
      attrs: {
        "type": "button",
        "name": "buttonAddPlanItem"
      },
      on: {
        "click": function($event) {
          return _vm.deleteOccupant(index)
        }
      }
    }, [(_vm.occupantIsDeleting) ? _c('spinner', {
      attrs: {
        "size": "small"
      }
    }) : _c('span', [_c('i', {
      staticClass: "fa fa-trash-o fa-1x push-5-r "
    }), _vm._v(_vm._s(_vm.labelButtonDeleteService[_vm.actualLanguage]))])], 1)])], 1)])
  }), 0), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "btn  btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.addOccupant
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonAddOccupant[_vm.actualLanguage]))])])], 1), _vm._v(" "), _c('div', {
    class: {
      'tab-pane': true, 'active': _vm.tabMenuSelector[3] == true
    }
  }, [_c('comp-unit-tags-display'), _vm._v(" "), _c('comp-compare-level-message-display')], 1)])])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7dd328ca","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/cost_splitting/Index.vue
// module id = 1569
// module chunks = 4